import requestHelper from '@/utils/requestHelper'

/**
 * 兑换优惠券
 * @param data
 */
export function getCoupon(data: any = {}) {
  return requestHelper.post('v4/demand/coupon/get', data)
}
